export default __webpack_public_path__ + "static/media/YAS0530.34I-27791_-17191_0.9a236d96.jpg";